import { Divider, Paper, Stack } from '@mui/material'

import { ReAllocatedJobsStat } from './ReAllocatedJobsStat'
import { ReAllocatedOverTimeCard } from './ReAllocatedOverTimeCard'
import { ReAllocatedPercentStat } from './ReAllocatedPercentStat'
import { useAllocationStabilityData } from './useAllocationStabilityData'

export const AllocationStabilityCards = () => {
  const { daily, summaryCount, summaryTotal, summaryPercentage, loading } =
    useAllocationStabilityData()

  return (
    <Stack spacing={3}>
      <Paper variant='outlined' sx={{ borderRadius: 2 }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          divider={<Divider orientation='vertical' flexItem variant='middle' />}>
          <ReAllocatedJobsStat
            summaryCount={summaryCount}
            summaryTotal={summaryTotal}
            loading={loading}
          />
          <ReAllocatedPercentStat summaryPercentage={summaryPercentage} loading={loading} />
        </Stack>
      </Paper>

      <ReAllocatedOverTimeCard daily={daily} loading={loading} />
    </Stack>
  )
}
